import { CheckEmailStatus } from "types/enums.ts";

import FormFieldData = App.Data.FormFieldData;

export type TenantRegistrationEmailStatus = CheckEmailStatus | "idle";

export const getTenantRegistrationStatus = (status: TenantRegistrationEmailStatus) => {
    const isSameRole = status === CheckEmailStatus.ExistingSameRole;
    const isPendingRole = status === CheckEmailStatus.ExistingPendingRole;
    const isEligibleExistingAccount =
        status === CheckEmailStatus.ExistingDifferentRole || status === CheckEmailStatus.ExistingNoAccess;

    return {
        isSameRole,
        isPendingRole,
        isEligibleExistingAccount,
        isExistingAccount: isSameRole || isPendingRole || isEligibleExistingAccount,
        canFillRegistration: status === CheckEmailStatus.New || isEligibleExistingAccount,
    };
};

export const getActiveRegistrationFields = (fields: FormFieldData[], excludedFormFieldIds: string[]) =>
    fields.filter((field) => field.id === null || !excludedFormFieldIds.includes(field.id));

export const getVisibleRegistrationFields = (fields: FormFieldData[]) => fields.filter((field) => !field.is_hidden);

export const pickRegistrationFieldValues = (
    fields: FormFieldData[],
    values: Record<string, unknown> | undefined
): Record<string, unknown> => {
    const allowedSystemNames = new Set(fields.map((field) => field.system_name));

    return Object.fromEntries(
        Object.entries(values ?? {}).filter(([systemName]) => allowedSystemNames.has(systemName))
    );
};
